import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import SeriesChanges from './SeriesChanges';

const SeriesChangesGet = ({ seriesId }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <ChangeCircleIcon />
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header='Зміни'
            disableClickOutside={true}
            content={
                <SeriesChanges
					seriesId={seriesId}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SeriesChangesGet